<template>

  <el-form ref='candidateForm' :model="site" :rules="rules" label-position="top" inline>

      <el-row type="flex" justify="center">
        <el-col :span="24" align="center">
          <h4>Site Name: <span :class="titleClass(site.status)">{{site.siteName ? site.siteName : 'not entered'}}</span></h4>
        </el-col>
      </el-row>

      <select-sharer v-if="!candidate.client_id" v-model="candidate.client_id" />

      <text-input
            label="Site Name"
            prop="siteName"
            required
            v-model="site.siteName"
            placeholder="Site Name"
             />

         <text-input
               label="Site ID"
               prop="siteId"
               required
               v-model="site.siteId"
               placeholder="Your Site ID"
               :max-length="16"
                />

       <text-input
            label="Your Ref"
            v-model="candidate.clientRef"
            placeholder="Your Ref"
            :max-length="16"
             />

       <text-input
            label="Title"
            v-model="candidate.title"
            placeholder="Title"
            :max-length="88"
             />

        <select-coverage
            v-model="candidate.stationType"
            label="Station Type"
             />

             <el-row :gutter="guts">
               <el-col :span="24">

                 <select-structure
                   label="Structure Type"
                   v-model="struct.structure_id"
                    />

                   <integer-input
                     label="Structure Height"
                     :min="1"
                     :max="121"
                     suffix="m."
                     v-model="struct.height"
                      />

                 <integer-input
                   label="Antenna AGL"
                   :min="1"
                   :max="121"
                   suffix="m."
                   placeholder="Height above ground in metres"
                   v-model="candidate.antennaHeight"
                    />


                 <integer-input
                     label="Site Width"
                     v-model="struct.width"
                     suffix="m."
                     placeholder="width in metres"
                      />

                 <integer-input
                     label="Site Depth"
                     v-model="struct.depth"
                     suffix="m."
                     placeholder="depth in metres"
                      />

               </el-col>
         </el-row>

        <el-row :gutter="guts">

           <el-col :span="8">
               <select-locality label="" v-model="loc" />
           </el-col>

           <el-col :span="8" align="center">

             <float-input
               v-if="!movePos"
               type="number"
               :decimals="12"
               v-model="site.latitude"
               placeholder="Latitude"
               prefix="Lat"
               suffix="&deg;"
               />
            <span v-else>Latitude:&nbsp;<b>{{site.latitude}}</b>&deg;</span>

          </el-col>

          <el-col :span="8" align="center">

             <float-input
               v-if="!movePos"
               :decimals="12"
               type="number"
               v-model="site.longitude"
               placeholder="Longitude"
               prefix="Lng" suffix="&deg;"
               />
             <span v-else>Longitude:&nbsp;<b>{{site.longitude}}</b>&deg;</span>

          </el-col>

      </el-row>

       <google-map
             v-if="this.site.latitude && this.site.longitude"
             :lat="this.site.latitude"
             :lng="this.site.longitude"
             draggable
             :zoom="14"
             width="100%"
             height="41.7vh"
             @update="updateMap" />

   </el-form>

</template>

<script>

import Vue from 'vue'
import VueEvents from 'vue-events'

Vue.use(VueEvents)

import {DATETIME_SQL_FORMAT, ENABLE_SAVE_EVENT} from '@/components/Data'  // , DISABLE_SAVE_EVENT


import SiteMixins from '@/mixins/SiteMixins'

import SelectCoverage from '@/components/atoms/selects/SelectCoverage'
import SelectLocality from '@/components/atoms/selects/SelectLocality'

import SelectSharer from '@/components/atoms/selects/SelectSharer'
import SelectStructure from '@/components/atoms/selects/SelectStructure'

import GoogleMap from '@/components/atoms/GoogleMap'

export default {
  mixins: [SiteMixins],

  components: {
    GoogleMap,
    SelectCoverage,
    SelectLocality,
    SelectSharer,
    SelectStructure
  },


  props: {

    clientId: {
      type: Number,
      default: null
    },

    tableRef: {
      type: String,
      default: 'sitetable'
    },

    status: {
      type: String,
      default: 'Candidate'
    }

  },



  methods: {


    updateMap (pos) {
      this.movePos = true
      this.site.latitude = pos.lat
      this.site.longitude = pos.lng
    },



    resetData () {
      this.site = {}
      this.$forceUpdate()
    },



    onSave () {

      this.site.region = this.setProp(this.site.region, this.loc[0])
      this.site.state = this.setProp(this.site.state, this.loc[1])
      this.site.district = this.setProp(this.site.district, this.loc[2])
      this.site.subdistrict = this.setProp(this.site.subdistrict, this.loc[3])
      this.site.zone = this.setProp(this.site.zone, this.loc[4])
//      console.log('location location location', this.loc)

      this.site.latitude = Number(this.site.latitude)
      this.site.longitude = Number(this.site.longitude)

      if (this.site.latitude && this.site.longitude) {
        this.candidate.markers = [{infoText: 'Option 1', icon: 'static/map/green-map.png', type: 'option', position: {lat: this.site.latitude, lng: this.site.longitude}}]
      }

      if (this.struct) {
        this.candidate.structure_id = this.struct.structure_id
        this.candidate.structureHeight = this.struct.height
      }

      this.site.structure = this.struct
      this.site.candidate = this.candidate

      this.saveForm(this, '/sites', null, this.site, this.site.siteName, this.success)
      this.$emit('update-stats')
      this.resetData()
    },




    onClose () {
      this.$emit('update-stats')
      this.resetData()
    },



    success (data) {

      this.action.site_id = data.id
      this.action.actionType = 'RTA'
      this.action.status = 'Active'
      this.action.priority = 'Medium'
      this.action.summary = data.status + ' Site [' + data.siteId + '] for ' + (this.org().shortName ? this.org().shortName : this.org().name)
      this.action.organisation_id = this.org().id
      this.action.actualDate = this.formatDateSql(new Date())
      this.action.targetDate = this.addDateTime(new Date(), 30, 'day', DATETIME_SQL_FORMAT)

      this.action.updated_at = data.updated_at
      this.action.updated_by = data.updated_by
      this.action.created_at = data.created_at

      this.saveForm(this, '/actions', null, this.action, this.action.summary, null, null, false)

      this.$events.fire(this.tableRef + '-refresh-table')

      this.resetData()
    },




    onCloseDialog () {
      this.resetData()
    }


  },




  data () {

    return {
      guts: 12,
      movePos: false,
      overide: false,
      tab: 'site',
      loc: [],
      site: this.getTableStruct('sites'),
      struct: this.getTableStruct('site_structures'),
      candidate: this.getTableStruct('site_candidates'),
      action: this.getTableStruct('actions'),
      rules: {
        siteName: [
          { required: true, message: 'Please enter site name', trigger: 'blur' }
        ],
        status: [
          { required: true, message: 'Please enter site status', trigger: 'blur' }
        ]
      }
    }

  },  // data



  created () {

    this.$events.fire(ENABLE_SAVE_EVENT)

    this.site.status = this.status
    this.candidate.client_id = this.clientId ? this.clientId : this.org().id
  }
}

</script>



// WEBPACK FOOTER //
// AcquireRequest.vue?bc80f1e6